import React from "react"
import { Row, Col, Typography, Button, Space } from "antd"
import { Link, NavLink, useMatch } from "react-router-dom"
import PropTypes from "prop-types"
import { oldRoutes } from "router/old-routes"
import SupportWindow from "pages/SupportWindow"

import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { showModal } from "modules/modals/reducer"

import DSBlueLogo from "assets/images/landing/DS-blue.svg"
import DSPinkLogo from "assets/images/landing/DS-pink.svg"
import veteranBadge from "assets/images/landing/veteran-badge.png"
import FacebookIcon from "assets/images/landing/facebook.svg"
import InstagramIcon from "assets/images/landing/instagram.svg"
import LinkedInIcon from "assets/images/landing/linkedin.svg"
import XIcon from "assets/images/landing/XIcon.svg"
import { routes } from "router"

GuestFooter.propTypes = {
  dark: PropTypes.bool,
  noPadding: PropTypes.bool,
  fluid: PropTypes.bool,
  className: PropTypes.string
}

export default function GuestFooter({ dark = false, noPadding = false, fluid = false, className }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isTripsPage = useMatch(oldRoutes.tripsPath())
  const isSportsman = useSelector((state) => state.user.is_sportsman)

  const openHandler = () => dispatch(showModal("support"))

  const classes = ["mt-auto z-1 bg-light layout-wrapper"]
  if (dark) classes.push("bg-dark text-bg-dark")
  if (className) classes.push(className)
  if (isTripsPage) classes.push("shadow")

  return (
    <footer className={classes.join(" ")}>
      <div className={"pt-3xl pb-5xl"}>
        <Row gutter={[20, 40]} align="top" justify={"space-between"}>
          <Col xl={12}>
            <div style={{ maxWidth: 200, position: "relative", marginBottom: 16 }}>
              <div style={{ padding: 8, margin: "-8px", marginBottom: 12 }}>
                <NavLink to={oldRoutes.rootPath()} state={{ scrollToTop: true }} title="Home">
                  {isSportsman ? (
                    <img src={DSBlueLogo} alt="DS Logo" width={42} height={41} style={{ marginRight: 12 }} />
                  ) : (
                    <img src={DSPinkLogo} alt="DS Logo" width={42} height={41} style={{ marginRight: 12 }} />
                  )}
                </NavLink>
                <img src={veteranBadge} alt="Veteran Badge" width={52} height={51} />
              </div>
              <Typography.Title level={5} style={{ margin: 0 }}>
                {t("footer.title", { year: new Date().getFullYear() })}
              </Typography.Title>
              <Typography.Text type="secondary" style={{ fontSize: 12, marginTop: 10, display: "block" }}>
                {t("footer.desc")}
              </Typography.Text>
            </div>
            <Space size={12} style={{ marginTop: 8 }}>
              <a href="https://www.facebook.com/DigitalSportsman?mibextid=LQQJ4d">
                <img src={FacebookIcon} alt="Facebook Icon" width={27} height={27} />
              </a>
              <a href="https://www.instagram.com/digitalsportsman/?hl=en">
                <img src={InstagramIcon} alt="Instagram Icon" width={27} height={27} />
              </a>
              <a href="https://www.linkedin.com/company/digitalsportsman/">
                <img src={LinkedInIcon} alt="Linked InIcon" width={27} height={27} />
              </a>
              <a href="/#">
                <img src={XIcon} alt="X Icon" width={27} height={27} />
              </a>
            </Space>
            <Typography.Text style={{ display: "block", marginTop: 16, fontSize: 12 }}>Call us on 252-DS-Guide</Typography.Text>
          </Col>
          <Col xl={12}>
            <div>
              <Typography.Text style={{ color: "#B7B7B7", textTransform: "uppercase", fontWeight: 500, fontSize: 14 }}>
                Help
              </Typography.Text>
              <ul
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                  marginTop: 15,
                  marginBottom: 0,
                  listStyle: "none",
                  fontSize: 16,
                  padding: 0
                }}
              >
                <li>
                  <Button type="link" onClick={openHandler} style={{ padding: 0, height: "auto" }}>
                    Customer Support
                  </Button>
                </li>
                <li>
                  <Link to={routes.faqPath()} state={{ scrollToTop: true }} className="link text-current">
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link to={routes.termsAndConditionsPath()} state={{ scrollToTop: true }} className="link text-current">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to={routes.privacyPolicyPath()} state={{ scrollToTop: true }} className="link text-current">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
      <SupportWindow />
    </footer>
  )
}
